module.exports = {"libs.subscriptionActivate.message.required":"Requerido","libs.subscriptionActivate.message.invalidPassword":"Tu contraseña debe tener 8 caracteres de longitud. Actualízala."}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/es/libs/subscriptionActivate.json
// module id = 768
// module chunks = 0